import { useMemo } from "react"
import PropTypes from "prop-types"
import { Tooltip } from "@mui/material"
import moment from "moment"

export default function MessageTime({ date, messageTimeRefresher }) {
  const dateObj = moment(date)

  // Since we want the time to update every minute, we need to include messageTimeRefresher in the dependency array
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const time = useMemo(() => dateObj.fromNow(), [dateObj, messageTimeRefresher])

  return <div className="message-time">
    <Tooltip
      title={dateObj.format("LLL")}
      classes={{
        tooltip: "ai-teammate-message-time-tooltip",
      }}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -10],
              },
            },
          ],
        },
      }}
    >
      {time}
    </Tooltip>
  </div>
}

MessageTime.propTypes = {
  date: PropTypes.string.isRequired,
  messageTimeRefresher: PropTypes.number,
}
